import Typography from "@mui/material/Typography/Typography"
import { Outlet, useNavigate } from "@tanstack/react-router"
import type { FC } from "react"

import { StoreProductModal } from "./StoreProductModal"

import { Button } from "@/components/common/Button"
import { TabletSuccessDialog } from "@/components/common/Modals"
import { DATE_FORMAT } from "@/constants/formats"
import { usePalletScanning } from "@/screens/Tablet/hooks"
import { formatDate } from "@/utils/date"

export const TabletLayout: FC = () => {
  const {
    scannedPallets,
    palletUIState,
    storedPallets,
    handleCloseModal,
    handleFinishStoring,
    updatePallet,
    clearStoredSuccess,
  } = usePalletScanning()

  const navigate = useNavigate()

  const agrNumber = storedPallets[0]?.goodsReceiptPalletRow?.goodsReceipt?.agrNumber || ""
  const updatedOn = storedPallets[0]?.updatedOn

  const handleSuccessDialogClose = (url?: string) => {
    clearStoredSuccess()

    if (!url) {
      return
    }

    navigate({ to: url })
  }

  return (
    <>
      <Outlet />

      {scannedPallets.length > 0 && (
        <StoreProductModal
          onClose={handleCloseModal}
          onFinish={handleFinishStoring}
          scannedPallets={scannedPallets}
          palletUIState={palletUIState}
          onPalletUpdate={updatePallet}
        />
      )}

      {storedPallets?.length > 0 && (
        <TabletSuccessDialog
          title='Products Stored'
          agrNumber={agrNumber}
          onClose={() => handleSuccessDialogClose()}
          actions={
            <Button
              variant='primary'
              onClick={() => handleSuccessDialogClose("/app/tablet/warehouse-receiving/stored")}
              data-testid='done-button'
            >
              Done
            </Button>
          }
        >
          <Typography variant='body2' className='mb-2 text-gray-700'>
            {storedPallets.length} {storedPallets.length === 1 ? "pallet" : "pallets"} stored
          </Typography>
          {storedPallets.map((pallet) => (
            <Typography key={pallet.referenceId} variant='body2' className='text-gray-700'>
              {pallet.goodsReceiptPalletRow?.product?.vendorDescription || "Unknown Product"}:
              {pallet.destinationWarehouseShelving?.aisleCode}, {pallet.destinationWarehouseShelving?.sectionCode},{" "}
              {pallet.destinationWarehouseShelving?.binNumber}| Ref ID#: {pallet.referenceId}
            </Typography>
          ))}
          <Typography variant='body2' className='mt-2 text-gray-700'>
            {formatDate(updatedOn, DATE_FORMAT.US_DATE_TIME)}
          </Typography>
        </TabletSuccessDialog>
      )}
    </>
  )
}
